import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./helpVerdadeDesafio.module.css";

import { useNavigate } from "react-router";
import { HelpBackgroundFlair } from "./desafiosPicantes";

import Header, {
  NoHeaderScroll,
  HomeHeaderLeft,
} from "../../components/navigation/header";

function HeaderCenter() {
  return <div></div>;
}

export default function VerdadeDesafioHelp() {
  const [animate, setAnimate] = useState(false);
  const [animate2, setAnimate2] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const interval1 = setInterval(() => {
      setAnimate(true);
      setTimeout(() => {
        setAnimate(false);
      }, 2000);
      setTimeout(() => {
        setAnimate2(true);
        setTimeout(() => {
          setAnimate2(false);
        }, 2000);
      }, 1000);
    }, 3000);

    return () => {
      clearInterval(interval1);
    };
  }, []);

  const handleNext = () => {
    navigate("/truth-or-dare/");
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={HomeHeaderLeft} HeaderCenter={HeaderCenter} />
      <HelpBackgroundFlair />
      <NoHeaderScroll className="p-5 pt-2">
        <div className="flex flex-col justify-between h-full">
          <h2 className="text-4xl font-bold">{t("howToPlay")}</h2>
          <div className="mt-7 mb-3">
            <p className="font-medium text-xl text-center">
              {t("howToPlayTruthOrDare")}
            </p>
          </div>
          <div className="flex-1 relative m-5">
            <div className={`${styles.img1} zoom-in`}>
              <img
                className={`${animate2 ? styles.animate : ""}`}
                src={require("../../assets/images/games/truthOrDare/pink.png")}
                alt="roulette2"
              />
              <div className={`${styles.text} ${styles.dare}`}>
                <span>{t("dare")}</span>
              </div>
            </div>
            <div className={`${styles.img2} zoom-in`}>
              <img
                className={`${animate ? styles.animate : ""}`}
                src={require("../../assets/images/games/truthOrDare/purple.png")}
                alt="roulette1"
              />
              <div className={`${styles.text} ${styles.truth}`}>
                <span>{t("truth")}</span>
              </div>
            </div>
          </div>
          <div className="flex items-end pt-5 pb-5">
            <button
              type="button"
              onClick={handleNext}
              className="btn btn-brand btn-small w-full pt-3 pb-3"
            >
              {t("next")}
            </button>
          </div>
        </div>
      </NoHeaderScroll>
    </div>
  );
}
